module.exports = __webpack_public_path__ + "img/icone-share.74153cfc.svg";